export default __webpack_public_path__ + "static/media/dashboard.9b6627f6.svg";